import { useState, useEffect, useRef } from 'react';
import PIOPIY from 'piopiyjs';

let piopiy;

const Call = () => {
    const [status, setStatus] = useState('Not connected');
    const [phoneNumber, setPhoneNumber] = useState('91XXXXXXXXXX');
    const [userId, setUserId] = useState('your_user_id');
    const [password, setPassword] = useState('your_password');

    const login = () => {
        piopiy = new PIOPIY({
            name: 'Your Name',
            debug: true,
            autoplay: true,
            ringTime: 60
        });

        piopiy.on('login', (res) => res.code === 200 && setStatus('Login successful'));
        piopiy.on('loginFailed', () => setStatus('Login failed'));
        piopiy.on('trying', () => setStatus('Trying...'));
        piopiy.on('ringing', () => setStatus('Ringing...'));
        piopiy.on('answered', () => setStatus('Call answered'));
        piopiy.on('hangup', () => setStatus('Call ended'));
        piopiy.on('ended', () => setStatus('Call finished'));
        piopiy.on('error', (err) => setStatus(`Error: ${JSON.stringify(err)}`));

        piopiy.login(userId, password, 'sbcind.telecmi.com'); // Change server as needed
    };

    const makeCall = () => {
        if (piopiy) {
            piopiy.call(phoneNumber);
            const callId = piopiy.getCallId();  // <-- get the current call's unique ID
            console.log('Call ID:', callId);
            setStatus(`Calling... Call ID: ${callId}`);
            // You can store callId in state if you want to show it or use it elsewhere
        } else {
            setStatus('Not logged in');
        }
    };

    return (
        <div>
            <h2>PIOPIY Web Call</h2>
            <input value={userId} onChange={e => setUserId(e.target.value)} placeholder="User ID" /><br />
            <input value={password} type="password" onChange={e => setPassword(e.target.value)} placeholder="Password" /><br />
            <button onClick={login}>Login</button><br /><br />
            <input value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder="Phone Number" /><br />
            <button onClick={makeCall}>Make Call</button>
            <p>Status: {status}</p>
        </div>
    );
};

export default Call;
